import React, { useState, useEffect } from 'react';
import { Button } from './Button';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';
import './Navbar.css';

function Navbar() {
  const [button, setButton] = useState(true);
  const [mobileMenu, setMobileMenu] = useState(false);

  const closeMobileMenu = () => {
    setMobileMenu(false);
  };

  const toggleMobileMenu = () => {
    setMobileMenu(!mobileMenu);
  };

  const showButton = () => {
    if (window.innerWidth <= 960) {
      setButton(false);
    } else {
      setButton(true);
    }
  };

  const handleApplyClick = () => {
    window.open('https://forms.gle/fLdFf7FwDvT5Gt6y8', '_blank', 'noopener,noreferrer');
    window.location.href = '/';
  };

  useEffect(() => {
    showButton();
  }, []);

  window.addEventListener('resize', showButton);

  return (
    <>
      <nav className="navbar">
        <div className="navbar-container">
          <Link to="/" className="navbar-logo" onClick={closeMobileMenu}>
            <img src={logo} alt="" className="navbar-logo-img" />
            QUANTIQ FINANCIAL
          </Link>
          <div className="menu-icon" onClick={toggleMobileMenu}>
            <i className="fas fa-bars" />
          </div>
          <ul className={mobileMenu ? 'nav-menu responsive' : 'nav-menu'}>
            <li className="nav-item">
              <Link to="/" className="nav-links" onClick={() => {
                closeMobileMenu();
                window.scrollTo(0, 0);
              }}>
                Home
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/MissionStatement" className="nav-links" onClick={() => {
                closeMobileMenu();
                window.scrollTo(0, 0);
              }}>
                Mission Statement
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/MeetTheTeam"
                className="nav-links"
                onClick={() => {
                  closeMobileMenu();
                  window.scrollTo(0, 0);
                }}
              >
                Meet the Team
              </Link>
            </li>
            {!button && (
              <li className="nav-item mobile-apply">
                <Button
                  buttonStyle="btn--outline"
                  onClick={handleApplyClick}
                >
                  APPLY NOW
                </Button>
              </li>
            )}
          </ul>
          {button && (
            <Button
              buttonStyle="btn--outline"
              onClick={handleApplyClick}
            >
              APPLY NOW
            </Button>
          )}
        </div>
      </nav>
    </>
  );
}

export default Navbar;